import { render, staticRenderFns } from "./InitialAccept.vue?vue&type=template&id=22198dd6&scoped=true&"
import script from "./InitialAccept.vue?vue&type=script&lang=js&"
export * from "./InitialAccept.vue?vue&type=script&lang=js&"
import style0 from "./InitialAccept.vue?vue&type=style&index=0&id=22198dd6&prod&lang=scss&"
import style1 from "./InitialAccept.vue?vue&type=style&index=1&id=22198dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22198dd6",
  null
  
)

export default component.exports